import React from 'react';
import { HouseWifi } from 'lucide-react'; // ✅ Importamos el nuevo ícono
import './SpawnBeaconIcon.css';

/**
 * Muestra el ícono de un Spawn Beacon.
 * @param {object} beacon - El objeto del beacon normalizado.
 * @param {string} size - 'small' (defecto) o 'big'.
 */
function SpawnBeaconIcon({ beacon, size = 'small' }) {
  if (!beacon) {
    console.warn('[SpawnBeaconIcon] Se intentó renderizar un ícono sin datos de beacon.');
    return null;
  }

  // Construimos las clases CSS dinámicamente
  const classNames = `spawn-beacon-icon size-${size} team-${beacon.teamClass}`;

  // Ajustamos el tamaño del ícono de Lucide basado en el prop 'size'
  const iconSize = size === 'big' ? 40 : 20; // Ajustamos un poco el tamaño para que se vea bien

  return (
    <div className={classNames}>
      <HouseWifi color="white" size={iconSize} /> {/* ✅ Usamos el nuevo ícono */}
    </div>
  );
}

export default SpawnBeaconIcon;